module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product-card', {
    attrs: {
      "product": _vm.product,
      "image": _vm.image,
      "module": _vm.module
    }
  }, [_c('div', {
    staticClass: "l-col-6@md",
    attrs: {
      "slot": "attributes"
    },
    slot: "attributes"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('color.label')))]), _vm._v("\n      " + _vm._s(_vm.product.color) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md",
    attrs: {
      "slot": "attributes"
    },
    slot: "attributes"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t(("netshoes.gridType." + (_vm.product.gridType) + ".label"))))]), _vm._v("\n      " + _vm._s(_vm.product.grid) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3073287e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/netshoes/ProductCard.vue
// module id = 3028
// module chunks = 0